import React from 'react'
import css from './card.module.scss'

export default ({ label, value }: { label: string; value: string[] | JSX.Element[] | string }) => (
  <tr className={css.row}>
    <td>{label}</td>
    <td>{Array.isArray(value) ? value.map((v, i) => <div key={i}>{v}</div>) : value}</td>
  </tr>
)
